module.exports = __webpack_public_path__ + "static/media/pattern-background.f70e2280.svg";